import { inject, Injectable } from '@angular/core';
import { catchError, Observable, of } from 'rxjs';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { MachineDto } from 'src/app/shared/dtos/machine.dto';
import { transformAndValidatePipe } from 'src/app/shared/utils/operators';
import { datadogLogs } from '@datadog/browser-logs';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class MachineService {
  http = inject(HttpClient);
  router = inject(Router);

  getMachine(id: string): Observable<MachineDto | null> {
    return this.http.get<MachineDto>(`/api/machine-config/${id}`).pipe(
      transformAndValidatePipe(MachineDto),
      catchError((err: HttpErrorResponse) => {
        if(err.status === 404){
          void this.router.navigate(['/not-found']);
          datadogLogs.logger.error('Error fetching machine:', {}, err);
        }
        datadogLogs.logger.error('Error fetching machine:', {}, err);
        return of(null);
      })
    );
  }
}
